var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.Numbers),function(n,key){return _c('span',{key:key},[_vm._v(_vm._s(n))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }